module.exports = {"650106001":"钢城片区街道","650106002":"火车西站片区街道","650106003":"王家沟片区街道","650106004":"乌昌路片区街道","650106005":"北站西路片区街道","650106007":"中亚北路片区街道","650106008":"中亚南路片区街道","650106009":"嵩山街片区街道","650106010":"高铁片区街道","650106011":"白鸟湖片区街道","650106012":"西湖片区街道","650106013":"北站东路片区街道","650106014":"两河片区街道","650106015":"乌鲁木齐站片区街道","650106198":"区直辖村级区划","650106501":"兵团十二师三坪农场","650106502":"兵团十二师五一农场","650106503":"新疆兵团十二师头屯河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650106.json
// module id = 3193
// module chunks = 0